import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDzECfZdnlAvOtU-tSHXqM6rPXjmMjVUTw",
  authDomain: "farmapp-8c392.firebaseapp.com",
  projectId: "farmapp-8c392",
  storageBucket: "farmapp-8c392.firebasestorage.app",
  messagingSenderId: "816563200126",
  appId: "1:816563200126:web:d55b48cc9740f57905782f",
  measurementId: "G-Y206PPCGS6"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);